module.exports = __webpack_public_path__ + "img/title-page-img.faa9536f.png";